import React from "react"
import './styles.scss'
import { Link, Route, Switch } from 'react-router-dom'
import Feeds, {TrendingFeeds} from './Posts/feed.componets'
import FullPost from './Posts/fullPost'
import { auth, firestore, signInWithGoogle, signOut } from '../firebase/firebase-utils'
import PostNews from './Posts/PostNews'

//Importing Dependencies
import { Row, Container, Col, Navbar, Nav, Form, Button, Modal, Image, Alert } from 'react-bootstrap'
import { FaBars, FaSearch } from 'react-icons/fa'
import { FcGoogle } from 'react-icons/fc'
import SearchResults from "./Posts/searchResults"


export default function TechNews(props) {
    const [User, setUser] = React.useState(null);
    const [Verified, setVerified] = React.useState(false);
    const [searchkey, setSearchKey] = React.useState('');
    const [show, setShow] = React.useState(false);
    const [list, setList] = React.useState([])

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    React.useEffect(() => {
        window.scrollTo({ top: 0 })
        const authenticate = () => {
            auth.onAuthStateChanged((user) => {
                if (user) {
                    setUser(user)
                    firestore.collection('authors')
                        .onSnapshot(querySnapshot => {
                            querySnapshot.forEach(doc => {
                                // doc.data() is never undefined for query doc snapshots
                                if (doc.data().uid === user.uid) {
                                    setVerified(true)
                                }
                            });
                        })
                } else {
                    setUser(null)
                }
            })
        }
        const KeyList = () => {
            firestore.collection("technews").onSnapshot((querySnapshot) => {
                var query = querySnapshot.docs.map(doc => {
                    return {
                        ...doc.data(),
                        docid: doc.id,
                    }
                });

                // quering
                query = query.map((item) => (
                    item.keys
                ));


                var list = [];
                query.forEach((item) => (
                    item.forEach((key) => (
                        list.push(key)
                    ))
                ));
                var arrList = [...new Set(list)]
                // iterations count for each number
                var irrCount = [];

                arrList.forEach((item) => {
                    var count = list.reduce((acc, elem) => {
                        return item === elem ? acc + 1 : acc
                    }, 0)
                    irrCount.push({ key: item, count: count })
                })

                irrCount = irrCount.sort((a, b) => {
                    return b.count - a.count
                })
                setList(irrCount)

            });
        }
        authenticate()
        KeyList();
        // eslint-disable-next-line
    }, [])


    const searchPost = () => {
        if (searchkey !== '') {
            props.history.push('/technews/searchresults?topic=' + searchkey)
        }
    }
    return (
        <div className="Technews">
            <Navbar className='Navbar' collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand className="heading" style={{ color: 'rgb(4, 5, 99)', fontSize: '30px' }} as={Link} to='/technews'>Daily Technews</Navbar.Brand>
                    <Navbar.Toggle className="toogle-btn" aria-controls="responsive-navbar-nav">
                        <FaBars />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link as={Link} to='/technews' className="navlink" >Home</Nav.Link>
                            <Nav.Link as={Link} to='/' className="navlink" >Main Page</Nav.Link>
                            {User ?
                                <Nav.Link className="navlink" onClick={handleShow}>Profile</Nav.Link>
                                :
                                <Nav.Link className="navlink" onClick={signInWithGoogle}>
                                    <FcGoogle style={{ marginBottom: '3px' }} />&nbsp;Sign In
                                </Nav.Link>
                            }
                            <Form.Group className="searchBtn navlink">
                                <Form.Control list="searchlist" type="text" placeholder="search by keyword..." onChange={(e) => setSearchKey(e.target.value)} />
                                <Button onClick={searchPost}><FaSearch /></Button>
                            </Form.Group>
                            <datalist id="searchlist">
                                {list.map(keyword=>(
                                    <option key={keyword.key}>{keyword.key}</option>
                                )) }
                            </datalist>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {User && Verified ?
                <PostNews email={User.email} userImg={User.photoURL} /> : ""
            }
            <Container style={{ minHeight: "70vh", marginTop: "50px" }}>
                <Row>
                    <Col sm={12} lg={8} style={{ minHeight: '70vh' }}>
                        <Switch>
                            <Route path="/technews" exact component={Feeds} />
                            <Route path='/technews/searchresults' component={SearchResults} />
                            <Route path='/technews/:id' exact component={FullPost} />
                        </Switch>
                    </Col>
                    <Col sm={12} lg={4}>
                        <div className="TrendingDiv">
                            <strong style={{color:'gray',fontSize:'20px',margin:'20px 0'}}># Trending News</strong><br/>
                            <TrendingFeeds/>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    {User ?
                        <div className="userDetails">
                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', flexWrap: 'wrap' }}>
                                <Image style={{ width: '50px', height: '50px', borderRadius: '25px', margin: '10px' }} src={User.photoURL} fluid />
                                <div style={{ display: 'flex', flexDirection: 'column', margin: '10px' }}>
                                    <h5>{User.displayName}</h5>
                                    <p style={{ fontSize: '14px' }}>{User.email}</p>
                                </div>
                                <Button variant="danger" style={{ height: 'fit-content', margin: '20px' }} onClick={() => { signOut(); window.location.reload(); }}>Log out</Button>
                            </div>
                            {Verified ? <span><Alert variant="success">You are verified</Alert></span> :
                                <div style={{ margin: '10px 0' }}>
                                    <p>Send us a mail to get verified as an author to post news.
                                    Do mention your topic you are intrested in. After you are verified,
                                       you will get a mail from <i>`techseminal@gmail.com`</i>.
                                       Verfication would be done ASAP.<br />
                                       To verify your mail click on verify
                                    </p>
                                    <a style={{ color: 'tomato', float: 'right' }} href="mailto:techseminal@gmail.com?subject=Verify me as author">verify me</a>
                                </div>
                            }
                        </div>
                        :
                        ""
                    }
                </Modal.Header>
            </Modal>
        </div >
    )
}